module.exports = __webpack_public_path__ + "img/c08_buildingtechmahoutmastery_Normal_ua.38ff39b0.webp";